/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OfferImageImgInner { 
    /**
     * The URL of the image
     */
    url?: string;
    /**
     * The width of the image
     */
    w?: number;
    /**
     * The height of the image
     */
    h?: number;
}

